import { queryOptions } from "@tanstack/vue-query";
import camelize from "camelcase-keys";

export const signupQueries = {
  checkEmailAvailability: (params: { email: string }) => {
    return queryOptions({
      queryKey: ["checkEmailAvailability", params.email],
      queryFn: async () => {
        const api = useNuxtApp().$api;

        const data = await api<{ exists: boolean }>(
          "/v1/members/checkEmailAvailability",
          {
            method: "POST",
            body: params,
          },
        );

        return camelize(data, { deep: true });
      },
    });
  },

  setupStripe: (
    params: MaybeRefOrGetter<{ paymentMethod: "card" | "us_bank_account" }>,
  ) => {
    return queryOptions({
      queryKey: ["setupPayment", toValue(params).paymentMethod],
      queryFn: async () => {
        const api = useNuxtApp().$api;

        const data = await api<{
          clientSecret: string;
          setupIntentId: string;
          customerId: string;
        }>("/v1/stripe/setup", {
          method: "POST",
          body: toValue(params),
        });

        return camelize(data, { deep: true });
      },
      gcTime: 0,
      staleTime: 0,
    });
  },

  getPostalData: (params: { postalCode: string }) => {
    return queryOptions({
      queryKey: ["postalData", params.postalCode],
      queryFn: async () => {
        const api = useNuxtApp().$api;

        const data = await api<{
          city: string;
          state: string;
          country: string;
        }>("/v1/google/postalCodeData?postalCode=" + params.postalCode, {
          method: "GET",
        });

        return camelize(data, { deep: true });
      },
    });
  },
};
